import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import LineChart from "../../../Components/Charts/LineChart";

const ServerAdoptionApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/service_adoption", body);
    return res.data;
  } catch (error) {
    console.error("Error fetching service adoption data:", error);
    throw error;
  }
};

const ServiceAdoption = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: ServiceAdoptionData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["ServiceAdoption", submitted],
    queryFn: () => ServerAdoptionApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className="bg-white rounded-md p-2 relative  shadow-lg h-full">
      <WaterMark />
      {isFetching ? (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      ) : isError ||
        !ServiceAdoptionData ||
        ServiceAdoptionData.length === 0 ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      ) : (
        <>
          <div className="text-lg font-bold text-gray-800 pl-2">
            Service Adoption Ratio (SAR)
          </div>
          <LineChart data={ServiceAdoptionData} />
        </>
      )}
    </div>
  );
};

export default ServiceAdoption;
